module.exports = __webpack_public_path__ + "static/img/2.f18ded9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/2.png
// module id = EMFY
// module chunks = 0